import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import FileUploadHeader from './FileUploadHeader';

const { Box, Button, Table } = vp;

type FileUploadHeaderProps = {
  product: string;
  fileName: string;
  numberOfTransactions: number;
  backToPrev: () => void;
  submit: () => void;
  transactionData: {
    [key: string]: string | number | null | undefined;
  }[];
};

type FC = FunctionComponent<FileUploadHeaderProps>;

const fileUploadReview: FC = (props: FileUploadHeaderProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Contacts.FileUpload.Review' });
  const { product, fileName, numberOfTransactions, backToPrev, submit, transactionData } = props;

  const TableProps: vp.TableProps = {
    id: 'bulkTransactionTable',
    name: 'review-bulk-transaction',
    columns: {
      Id: { header: t('id', { defaultValue: 'Id' }), align: 'left' },
      Name: { header: t('name', { defaultValue: 'Name' }), align: 'left' },
      Account: { header: t('account', { defaultValue: 'Account' }), align: 'left' },
    },
    rows:
      Object.values(transactionData).map((transaction, index) => ({
        Id: String(index + 1),
        Name: String(
          transaction.CompanyName ||
            transaction.BusinessName ||
            transaction.RecipientName ||
            transaction.ReceiverName ||
            [transaction.FirstName, transaction.LastName].filter(Boolean).join(' '),
        ),
        Account: (
          <>
            {transaction.EmailAddress ? String(transaction.EmailAddress) : ''}
            {product === 'ACH' ? `${String(transaction.ABARoutingNumber)}-${String(transaction.AccountNumber)}` : ''}
            {transaction.CardNumber ? transaction.CardNumber : ''}
            {transaction.CreditCardNumber ? transaction.CreditCardNumber : ''}
            {transaction.FinancialInstitutionNumber && product !== 'ACH'
              ? `${String(transaction.FinancialInstitutionNumber)}-`
              : ''}
            {transaction.BranchTransitNumber && product !== 'ACH' ? `${String(transaction.BranchTransitNumber)}-` : ''}
            {transaction.AccountNumber && product !== 'ACH' ? `${String(transaction.AccountNumber)}` : ''}
            {transaction.Token ? `Token: ${String(transaction.Token)}` : ''}
            {transaction.FlinksAccountID ? `Token: ${String(transaction.FlinksAccountID)}` : ''}
            {transaction.FlinksLoginID ? `FlinksLoginID: ${String(transaction.FlinksLoginID)}` : ''}
            {transaction.PlaidPublicToken ? `PlaidPublicToken: ${String(transaction.PlaidPublicToken)}` : ''}
            {transaction.PlaidAccessToken ? `PlaidAccessToken: ${String(transaction.PlaidAccessToken)}` : ''}
            {transaction.PlaidAccountID ? `PlaidAccountID: ${String(transaction.PlaidAccountID)}` : ''}
            {transaction.PlaidProcessorToken ? `PlaidProcessorToken: ${String(transaction.PlaidProcessorToken)}` : ''}
            {transaction.InveriteRequestGUID ? `InveriteRequestGUID: ${String(transaction.InveriteRequestGUID)}` : ''}
          </>
        ),
      })) || [],
  };
  return (
    <div>
      <Box pb="lg" mb="md" gap="sm" jc="sb" width="100%" wrap="wrap">
        <FileUploadHeader
          product={product}
          fileName={fileName}
          numberOfTransactions={numberOfTransactions}
          backToPrev={() => {
            backToPrev();
          }}
        />

        <Table {...TableProps} />
        <Box width="100%" jc="fe" mt="md">
          <Button
            id="submit-bulk-transaction"
            label={t('submit', { defaultValue: 'Submit' })}
            width="140px"
            noShadow
            type="submit"
            onClick={() => {
              submit();
            }}
          />
        </Box>
      </Box>
    </div>
  );
};

export default fileUploadReview;
